import ReferA from './ReferA';
import ReferB from './ReferB';
import ReferC from './ReferC';
import ReferD from './ReferD';
import ReferE from './ReferE';
import ReferF from './ReferF';
import ReferG from './ReferG';
import ReferH from './ReferH';
import ReferI from './ReferI';

const Refer = {
  ReferA,
  ReferB,
  ReferC,
  ReferD,
  ReferE,
  ReferF,
  ReferG,
  ReferH,
  ReferI
};

export default Refer;



// WEBPACK FOOTER //
// ./src/containers/Refer/index.jsx